import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DatePickerTextbox from "@/components/DatePickerTextbox.vue";
let BenefitsTeamManagerModal = class BenefitsTeamManagerModal extends Vue {
    shortDate(date) {
        return window.dateHandler.formatDateNoTime(date);
    }
    updateTeamManagerBenefit(item) {
        console.log(item);
        this.$store
            .dispatch("adminUpdateTeamManagerBenefit", {
            userId: this.$props.employee.userId,
            data: item,
        })
            .then((response) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The TeamManager benefit has been updated",
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsTeamManagerModal.vue - adminUpdateTeamManagerBenefit");
        });
    }
    createNewTeamManagerBenefit() {
        //this.$data.createTeamManagerBenefit.teamId = this.$props.employee.teamId;
        this.$store
            .dispatch("adminUpdateTeamManagerBenefit", {
            userId: this.$props.employee.userId,
            data: this.$data.createTeamManagerBenefit,
        })
            .then((response) => {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "The TeamManager benefit has been created",
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "components/BenefitsTeamManagerModal.vue - createTeamManagerBenefit");
        });
    }
};
BenefitsTeamManagerModal = __decorate([
    Component({
        data() {
            return {
                trueVal: true,
                loading: true,
                theme: this.$store.getters.getTheme,
                createTeamManagerBenefit: {
                    fixedSalary: 0,
                    pension: 0,
                    vacationDays: 0,
                    from: "",
                    to: null,
                    teamId: "",
                    maxBonus: "",
                },
                selectedTeamManagerBenefit: [],
                createNewTeamManagerBenefitDialog: false,
                teamManagerHeaders: [
                    { text: "Fixed Salary", value: "fixedSalary" },
                    { text: "From", value: "from" },
                    { text: "To", value: "to" },
                    { text: "", value: "delete" },
                ],
            };
        },
        props: ["employee"],
        mounted() {
            this.$data.loading = false;
        },
        computed: {
            showModal: {
                get() {
                    return this.$data.trueVal;
                },
                set(newValue) {
                    this.$data.trueVal = newValue;
                    if (this.$data.trueVal === false) {
                        this.$emit("close"); //we need to send the close event if the dialog is closed by clicking outside rather than on the button
                    }
                },
            },
        },
        methods: {
            close() {
                this.$emit("close");
            },
        },
        components: {
            DatePickerTextbox,
        },
    })
], BenefitsTeamManagerModal);
export default BenefitsTeamManagerModal;
